import { useMutation } from '@tanstack/react-query';

export function useCreateProjectsAnalyticsProjectsReportsSignatureStatusReportsExportProcessMutation() {
  return useMutation({
    mutationKey: [
      'createProjectsAnalyticsProjectsReportsSignatureStatusReportsExportProcess',
    ],
    mutationFn: async ({ params }) => {
      const response = await axios.post(
        '/projects_analytics/projects_reports/signature_status_reports/export_processes',
        { export_process: params },
      );

      return response.data;
    },
  });
}
